<script>
    import Modal from "./Modal.svelte";

    import { locale } from "../stores.js";

    export let showDeleteModal;

    export let deleteMessage = "";

    export let deleteCallback;
</script>

<Modal bind:showModal={showDeleteModal}>
    <div slot="title" />
    <div slot="body">
        <div class="message">
            {deleteMessage}
        </div>

        <div class="buttons">
            <button
                class="btn btn-red"
                on:click={() => {
                    deleteCallback();
                    showDeleteModal = false;
                }}
            >
                {$locale.yes || ""}
            </button>

            <button
                class="btn"
                on:click={() => {
                    showDeleteModal = false;
                }}
            >
                {$locale.no || ""}
            </button>
        </div>
    </div>
</Modal>

<style>
    .message {
        font-size: 20px;
        margin-bottom: 20px;
    }

    .buttons {
        display: flex;
        justify-content: space-around;
    }

    button {
        width: 60px;
        font-size: 20px;
        padding: 10px;
    }
</style>
